

import { productosApi } from "../../apis";
import { useProductosStore } from "../../stores/productos/productos";

import Swal from "sweetalert2";





export const productosParaCarrusel = async() => {
    try {
        const { data } = await productosApi.get('/publicidad');
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const listadoTodosProductos = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await productosApi.get('/todos', { params });
        useProductosStore.setState({ totalProductos : data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const productosXID = async(id) => {
    try {
        const { data } = await productosApi.get(`/producto/${id}`);
        return data.producto;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const startSavingProducto = async( datos ) => {
    try {
        await productosApi.post('new', datos);
        Swal.fire('Exitoso', 'Producto Creado', 'success');
        return true;
    } catch (error) {
        console.log(error);
        Swal.fire('Error', error.response.data?.msg || '', 'error');
        return false;
    }
} 



export const startEditarProducto = async(producto) => {
    try {
        const formData = new FormData();
        if (producto?.img && typeof producto?.img !== 'string') {
            formData.append('images', producto.img);
        }

        Object.entries(producto).forEach(([key, value]) => {
            const valorFormateado = (value !== null && typeof value === "object") ? JSON.stringify(value) : String(value ?? '');
            formData.append(key, valorFormateado);
        });

        await productosApi.put(`/${producto.id}`, formData);
        Swal.fire('Exitoso', 'Producto Actualizado', 'success');
        return true;

    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}


export const productosXCategoria = async({ id, termino }) => {
    try {
        const params = new URLSearchParams();
        params.append('id',  id);
        params.append('termino',  termino);

        const { data } = await productosApi.get(`/xid/categoria`, { params });
        return data.productos;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}



export const productosSoloTerminados = async() => {
    try {
        const { data } = await productosApi.get(`/solo/terminados`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}


















